"use client";

import { useEffect, useState } from "react";

import { CommandSchedulerDialog } from "@/components/aios-command/chat/command-scheduler-dialog";
import { useCommandV2CreateSchedule } from "@/hooks/use-command-v2-create-schedule";
import type { CommandSchedulerSubmitInput } from "@/types/command-scheduler";

interface CommandV2ComposerSchedulerDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    prompt: string;
    sessionId?: string | null;
    fileIds?: string[];
    agentName?: string;
    agentModelLabel?: string;
    onScheduled?: () => void;
}

export function CommandV2ComposerSchedulerDialog({
    open,
    onOpenChange,
    prompt,
    sessionId,
    fileIds = [],
    agentName,
    agentModelLabel,
    onScheduled,
}: CommandV2ComposerSchedulerDialogProps) {
    const { createFromSchedulerSubmit, isPending } = useCommandV2CreateSchedule();
    const [promptText, setPromptText] = useState(prompt);

    useEffect(() => {
        if (!open) return;
        setPromptText(prompt);
    }, [open, prompt]);

    const handleSubmit = (input: CommandSchedulerSubmitInput) => {
        createFromSchedulerSubmit(
            {
                prompt: promptText.trim(),
                sessionId,
                fileIds,
                runAt: input.runAt,
                description: input.description,
                scheduleType: input.scheduleType,
                cronExpression: input.cronExpression,
                newSession: input.newSession,
            },
            () => {
                onScheduled?.();
                onOpenChange(false);
            }
        );
    };

    return (
        <CommandSchedulerDialog
            open={open}
            onOpenChange={onOpenChange}
            isSubmitting={isPending}
            onSubmit={handleSubmit}
            agentName={agentName}
            agentModelLabel={agentModelLabel}
            prompt={promptText}
            onPromptChange={setPromptText}
            hasExistingSession={Boolean(sessionId)}
        />
    );
}
